import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStation from './station.reducer';
import * as TourState from '@tour/_ngrx/tour.selectors'
import { StationLongDto } from '@api/rest';

export const selectStationState = createFeatureSelector<fromStation.State>(
  fromStation.stationsFeatureKey
);

export const getStations = createSelector(selectStationState, fromStation.selectAll);
export const getStationsDict = createSelector(selectStationState, fromStation.selectEntities);
export const getSelectedId = createSelector(selectStationState, state => state.selected);

export const getSelectedSubstationId = createSelector(selectStationState, state => state.selectedSubstation);

export const getSelected = createSelector(
  getStationsDict,
  getSelectedId,
  (stations, id): StationLongDto => stations[ id ]
);

export const getSelectedSubstations = createSelector(
  getStationsDict,
  getSelected,
  (
    dict,
    station
  ): StationLongDto[] => station?.substation_order?.map(ref => dict[ ref ]).filter(Boolean) || []
);

export const getTourStations = createSelector(
  getStationsDict,
  TourState.getSelected,
  (
    dict,
    tour
  ): StationLongDto[] => tour?.station_refs?.map(ref => dict[ ref ]).filter(Boolean) || []
);

export const getFavorites = createSelector(selectStationState, state => state.favorites);
